import React from 'react';
import { hasWindow } from 'core/includes/window';

type Props = {
    children: React.ReactElement
}

const NoSsr: React.FC<Props> = ({ children }) => hasWindow ? children : null;

export default NoSsr;